// extracted by mini-css-extract-plugin
export default {"GeoData__header":"GeoData_GeoData__header__jhvof","tourButton":"GeoData_tourButton__vtub5"};